import auth from "./locales/en/auth.json";
import common from "./locales/en/common.json";
import dashboard from "./locales/en/dashboard.json";
import order from "./locales/en/order.json";
import product from "./locales/en/product.json";
import settings from "./locales/en/settings.json";
import transaction from "./locales/en/transaction.json";
import users from "./locales/en/users.json";
import voucher from "./locales/en/voucher.json";

export const resources = {
  en: {
    auth,
    common,
    dashboard,
    order,
    product,
    settings,
    transaction,
    users,
    voucher
  }
};
